import { optionalDate } from '../optionalDate';
/**
 * This is a hook that shims the `string`-based date state setter into a
 * `Date`-based state setter.
 */
export const makeDateSetterFromStringSetter = (setState) => (value) => {
    // State setters may be called with a `Date` object, a `string` or a
    // function that returns a `Date` object or a `string`.
    if (typeof value === 'function') {
        setState(state => {
            var _a;
            return (_a = value(optionalDate(state))) === null || _a === void 0 ? void 0 : _a.toISOString();
        });
    }
    // Handle `null`, `undefined` and `''` as `undefined`.
    if (!value) {
        setState(undefined);
    }
    // Handle `string` values being converted to `Date` objects.
    if (value instanceof Date) {
        setState(value === null || value === void 0 ? void 0 : value.toISOString());
    }
};
